import { render, staticRenderFns } from "./EmpProjectsList.vue?vue&type=template&id=0b3f395b"
import script from "./EmpProjectsList.vue?vue&type=script&lang=js"
export * from "./EmpProjectsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports